export default "__VITE_ASSET__BDawtylj__"